import React, { useState, useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField } from "availity-reactstrap-validation"

const AddProducerAdvance = () => {
  const formRef = useRef(null)
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [centers, setCenters] = useState([])
  const [routes, setRoutes] = useState([])
  const [allRoutes, setAllRoutes] = useState([])
  const [vlccs, setVlccs] = useState([])
  const [allVlccs, setAllVlccs] = useState([])
  const [producers, setProducers] = useState([])
  const [allProducers, setAllProducers] = useState([])
  const [selectedCC, setSelectedCC] = useState("")

  useEffect(() => {
    const getData = async () => {
      try {
        const [chilResp, rouResp, ccResp, proResp] = await Promise.all([
          api.get("centers"), api.get("routes"), api.get("collection-centers"), api.get("producers")
        ])
        setCenters(Array.isArray(chilResp.data.data) ? chilResp.data.data : chilResp.data.data?.data || [])
        const r = Array.isArray(rouResp.data.data) ? rouResp.data.data : rouResp.data.data?.data || []; setAllRoutes(r); setRoutes(r)
        const v = Array.isArray(ccResp.data.data) ? ccResp.data.data : ccResp.data.data?.data || []; setAllVlccs(v); setVlccs(v)
        const p = Array.isArray(proResp.data.data) ? proResp.data.data : proResp.data.data?.data || []; setAllProducers(p); setProducers(p)
      } catch (err) { console.error(err) }
    }; getData()
  }, [])

  const handleCCChange = ccId => { setSelectedCC(ccId); setRoutes(ccId ? allRoutes.filter(r => String(r.chillingCenter) === String(ccId)) : allRoutes); setVlccs(allVlccs); setProducers(allProducers) }
  const handleRouteChange = routeId => { setVlccs(routeId ? allVlccs.filter(v => String(v.route) === String(routeId)) : allVlccs); setProducers(allProducers) }
  const handleVlccChange = vlccId => { setProducers(vlccId ? allProducers.filter(p => String(p.collectionCenter) === String(vlccId) || String(p.center) === String(vlccId)) : allProducers) }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      const response = await api.post("create-producer-advance", values)
      if (response.data.success === true) {
        formRef.current.reset(); setSubmitted(true)
        setSelectedCC(""); setRoutes(allRoutes); setVlccs(allVlccs); setProducers(allProducers)
        setTimeout(() => setSubmitted(false), 3000)
      }
    } catch (error) { console.error(error) }
    setLoading(false)
  }

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row><Col md={6}><h4>Add Producer Cash Advance</h4></Col>
          <Col md={6} style={{ textAlign: "right" }}><Link to="/producer-cash-advances" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link></Col></Row>
      </div>
      <div className="dashContent">
        <AvForm ref={formRef} className="form-horizontal" onValidSubmit={handleValidSubmit}>
          <Row>
            <Col md={6}><div className="mb-3"><AvField type="select" name="chillingCenter" label="Chilling Center *" required onChange={e => handleCCChange(e.target.value)}>
              <option value="">Select Chilling Center</option>{centers.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}
            </AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="route" label="Route *" required onChange={e => handleRouteChange(e.target.value)}>
              <option value="">Select Route</option>{routes.map((r, i) => <option key={i} value={r.id}>{r.routeName}</option>)}
            </AvField></div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3"><AvField type="select" name="center" label="VLCC (Collection Center) *" required onChange={e => handleVlccChange(e.target.value)}>
              <option value="">Select VLCC</option>{vlccs.map((v, i) => <option key={i} value={v.id}>{v.centerName}</option>)}
            </AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="producer" label="Producer *" required>
              <option value="">Select Producer</option>{producers.map((p, i) => <option key={i} value={p.id}>{p.producerName}</option>)}
            </AvField></div></Col>
          </Row>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="advanceDate" label="Advance Date *" type="date" required /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="advanceAmount" label="Advance Amount *" type="text" required validate={{ pattern: { value: /^[0-9,]+(\.[0-9]{1,2})?$/, errorMessage: "Enter a valid amount" } }} /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="deductionAmount" label="Deduction Per Bill *" type="text" required validate={{ pattern: { value: /^[0-9,]+(\.[0-9]{1,2})?$/, errorMessage: "Enter a valid amount" } }} /></div></Col>
          </Row>
          <Row><Col md={12}><div className="mb-3"><AvField name="remarks" label="Remarks" type="textarea" /></div></Col></Row>
          <div className="mb-3 row mt-4">
            <div className="col-6">{submitted && <UncontrolledAlert color="success"><strong>Producer Cash Advance Added!</strong></UncontrolledAlert>}</div>
            <div className="col-6 text-end"><button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
              {loading ? <><Spinner size="sm" /> <span>Adding...</span></> : <span>Add Advance</span>}</button></div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}
export default AddProducerAdvance
